// src/index.ts
function decodeBase64(str) {
  if (typeof atob === "function") {
    return atob(str);
  }
  if (typeof globalThis !== "undefined") {
    const maybeBuffer = globalThis.Buffer;
    if (maybeBuffer) {
      return maybeBuffer.from(str, "base64").toString("binary");
    }
  }
  throw new Error("No base64 decoder available in environment");
}
function decodeJwt(token) {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = parts[1];
    if (!payload) return null;
    const padded = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = decodeBase64(padded);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}
function isTokenExpired(token, thresholdMs = 0) {
  const payload = decodeJwt(token);
  if (!payload) return true;
  const expiresAtMs = payload.exp * 1e3;
  return Date.now() + thresholdMs >= expiresAtMs;
}
function getUserIdFromToken(token) {
  return decodeJwt(token)?.sub ?? null;
}
function getTokenExpiry(token) {
  const payload = decodeJwt(token);
  if (!payload) return null;
  return new Date(payload.exp * 1e3);
}
function buildSession(accessToken) {
  const payload = decodeJwt(accessToken);
  if (!payload) return null;
  return {
    accessToken,
    userId: payload.sub,
    email: payload.email,
    isExpired: isTokenExpired(accessToken),
    expiresAt: getTokenExpiry(accessToken)
  };
}
var ROLE_HIERARCHY = {
  OWNER: 3,
  ADMIN: 2,
  MEMBER: 1
};
function hasRoleAtLeast(userRole, required) {
  if (!userRole) return false;
  return (ROLE_HIERARCHY[userRole] ?? 0) >= (ROLE_HIERARCHY[required] ?? 0);
}
function isAdminOrOwner(role) {
  return hasRoleAtLeast(role, "ADMIN");
}

export { buildSession, decodeJwt, getTokenExpiry, getUserIdFromToken, hasRoleAtLeast, isAdminOrOwner, isTokenExpired };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map